import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {useGetOptionsSelect} from "../../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import {usePropsSelect} from "../../../../../hooks/useProps/usePropsSelect";
import useDidMountEffect from "../../../../../hooks/useDidMountEffect/useDidMountEffect";
import {
    getAllAreasAPI, getAllCargosAPI, getCargosDeEmpleadosActivosAPI, getDivisionesAPI,
    getExtradatasAPI, getFlujoDocumentoScopeAccionesAPI,
    getFlujoDocumentoScopeCampoAPI,
    getFlujoDocumentoToEditAPI, getPlantillasGestionDocumentoAPI, getRequiereExtradataListAPI,
    getRolesActivosAPI,
    getTiposAdministradorAPI, getTiposDistribucionAPI, getUnidadesDeEmpleadosActivosAPI,
} from "../../../../../consumers/backendApisUrls";
import {initialAllOptionPromises, isNullOrUndefinded} from "../../../../../helper/utils";
import Paso1 from "./Pasos/Paso1";
import Paso2 from "./Pasos/Paso2";
import Paso3 from "./Pasos/Paso3";
import Paso4 from "./Pasos/Paso4";
import ModalForm from "../../../../../components/modalComponents/ModalForm";
import StepperFlujoDocumentos from "./components/StepperFlujoDocumentos";
import {usePropsInputs} from "../../../../../hooks/useProps/usePropsInput";
import {IdTipoDistribucion} from "../../../constantes/constantes";
import {v4 as uuidv4} from 'uuid';
import {useManageGetRequest} from "../../../../../hooks/useManageGetRequest/useManageGetRequest";

const KEYS = {
    idCampanaBeneficio: "IdCampanaBeneficio",
    cartaAutorizacionBeneficioFileViewModel: "CartaAutorizacionBeneficioFileViewModel",
    IdTipoBeneficioItem: "IdTipoBeneficioItem",
    IdUbicacionBeneficioItem: "IdUbicacionBeneficioItem",

    NombreActividad: "NombreActividad",
    NombreFlujoDocumento: "NombreFlujoDocumento",
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    Instrucciones: "Instrucciones",
    ProcedimientoFile: "ProcedimientoFile",
    IdAreaAdministrador: "IdAreaAdministrador",
    IdEmpleadoAdministrador: "IdEmpleadoAdministrador",
    IdEmpleadoVisorAdministrador: "IdEmpleadoVisorAdministrador",
    IdRolAdministrador: "IdRolAdministrador",
    IdRolVisorAdministrador: "IdRolVisorAdministrador",

    IdTipoVisorAdministrador: "IdTipoVisorAdministrador",
    IdTipoAdministrador: "IdTipoAdministrador",
    RenderEditorDocumento: "RenderEditorDocumento",
    EmpleadoAdministrador: "EmpleadoAdministrador",
    EmpleadoVisorAdministrador: "EmpleadoVisorAdministrador",

    IdPlantillaDistribucion: "IdPlantillaDistribucion",
    DocumentoContent: "DocumentoContent",
    IdRequiereExtradataDistribucion: "IdRequiereExtradataDistribucion",
    CantidadExtraDatas: "CantidadExtraDatas",

    DocumentoGenerico: "DocumentoGenerico",

    IdsUnidades: "IdsUnidades",
    Incluye: "Incluye",
    IdsCargos: "IdsCargos",

    IdDocumentoScopeCampo: "IdDocumentoScopeCampo",
    IdDocumentoScopeAccion: "IdDocumentoScopeAccion",

    IdTipoDistribucion: "IdTipoDistribucion",
    ArchivoCargaDistribucion: "ArchivoCargaDistribucion",

    IncorporarNuevosColaboradoresAutomaticamente: "IncorporarNuevosColaboradoresAutomaticamente",
    ObligatorioParaDescargarBoletaDePago: "ObligatorioParaDescargarBoletaDePago"
};

const KEYS_DROPDOWN = [
    "IdTipoDistribucion",
    "IdAreaAdministrador", "IdRolAdministrador", "IdRolVisorAdministrador",
    "IdTipoVisorAdministrador", "IdTipoAdministrador",
    "IdPlantillaDistribucion", "IdRequiereExtradataDistribucion", "CantidadExtraDatas",
    "IdDocumentoScopeCampo", "IdsUnidades", "IdsCargos", "IdDocumentoScopeAccion"
];

const SECTION_NAME = "CrearDocumento";
const STEPS = {
    stepOne: {id: 1, name: "Datos"},
    stepTwo: {id: 2, name: "Plantilla"},
    stepThree: {id: 3, name: "Distribución"},
    stepFour: {id: 4, name: "Pasos"},
};

const CrearDocumento = ({
                            toggleModal,
                            refreshPage,
                            IdFlujoDocumento,
                            disableInputs,
                            isCreate
                        }) => {
        const [manageGetRequest] = useManageGetRequest();
        const [formValues, setFormValues] = useState({});
        const [allDropdowns, setAllDropdowns] = useState([]);
        const [getOption] = useGetOptionsSelect();
        const [selectProps] = usePropsSelect(
            allDropdowns,
            formValues,
            setFormValues,
            SECTION_NAME
        );

        const [paso3Filtros, setPaso3Filtros] = useState([]);
        const [propsInputs] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
        const [currentStep, setCurrentStep] = useState(1);
        const [sendCurrentStep, setSendCurrentStep] = useState({
            step: 0,
            isSent: false,
        });

        const [paso4Filas, setPaso4Filas] = useState([{"rowId": uuidv4()}])
        const botonGuardarRef = useRef(null);
        const [puedeEditar, setPuedeEditar] = useState(isCreate);

        useDidMountEffect(() => {
            /*
            if (isNullOrUndefinded(formValues[KEYS.CantidadExtraDatas]) && formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.ConCarga.Id) {
                setFormValues(lastData => ({
                    ...lastData,
                    [KEYS.IdTipoDistribucion]: null,
                    [KEYS.ArchivoCargaDistribucion]: null
                }))
            }*/

            if (!isNullOrUndefinded(formValues[KEYS.CantidadExtraDatas]) && formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.PorFiltro.Id) {
                setFormValues(lastData => ({
                    ...lastData,
                    [KEYS.IdTipoDistribucion]: null
                }))
                setPaso3Filtros([])
            }
        }, [formValues[KEYS.CantidadExtraDatas]])

        useDidMountEffect(() => {
            if (sendCurrentStep.isSaved && !sendCurrentStep.isSent) {
                let newStep = currentStep;
                validateStep(++newStep);
                setSendCurrentStep({step: 0, isSent: false});
            } else {
                setSendCurrentStep({step: currentStep, isSent: false});
            }
        }, [sendCurrentStep.isSaved]);

        useEffect(() => {
            getInitData()
        }, [])

        const getInitData = async () => {
            getDropdowns();
            if (!isNullOrUndefinded(IdFlujoDocumento)) {
                await manageGetRequest(getFlujoDocumentoToEditAPI(IdFlujoDocumento), callbackSuccessGetFlujoDocumentoToEdit, false);
            }
        }

        const callbackSuccessGetFlujoDocumentoToEdit = (response) => {
            setFormValues(response.data.FormValues);
            setPaso3Filtros(response.data.FiltrosPaso3);
            setPaso4Filas(response.data.StepsPaso4);
            setPuedeEditar(response.data.PuedeEditar);
        }

        const handleClick = (e, clickType) => {
            if (e) e.preventDefault();

            let newStep = currentStep;
            if (clickType === "save") {
                setSendCurrentStep({step: currentStep, isSent: true});
            } else {
                if (currentStep === STEPS.stepFour.id) {
                    setFormValues({...formValues, [KEYS.cartaAutorizacionBeneficioFileViewModel]: undefined})
                }
                validateStep(--newStep);
            }
        };

        const validateStep = (newStep) => {
            if (newStep > 0 && newStep <= Object.keys(STEPS).length) {
                setCurrentStep(newStep);
            }
        };

        const getDropdowns = async () => {
            let apiGetDivisiones = getDivisionesAPI();
            let apiGetCargos = getAllCargosAPI();
            if (isCreate){
                apiGetDivisiones = getUnidadesDeEmpleadosActivosAPI();
                apiGetCargos = getCargosDeEmpleadosActivosAPI();
            }

            const dropdownsPromises = () => [
                getOption(getTiposDistribucionAPI()),
                getOption(getAllAreasAPI()),
                getOption(getRolesActivosAPI()),
                getOption(getRolesActivosAPI()),
                getOption(getTiposAdministradorAPI()),
                getOption(getTiposAdministradorAPI()),
                getOption(getPlantillasGestionDocumentoAPI()),
                getOption(getRequiereExtradataListAPI()),
                getOption(getExtradatasAPI()),
                getOption(getFlujoDocumentoScopeCampoAPI()),
                getOption(apiGetDivisiones),
                getOption(apiGetCargos),
                getOption(getFlujoDocumentoScopeAccionesAPI()),
            ]
            await initialAllOptionPromises(dropdownsPromises, KEYS_DROPDOWN, handleDropdowns);
        }

        const handleDropdowns = (data) => {
            const updatedData = [...data];
            setAllDropdowns(updatedData);
        }

        const commonProps = () => {
            return {
                sendCurrentStep,
                setSendCurrentStep,
                KEYS,
                selectProps,
                SECTION_NAME,
                setFormValues,
                formValues,
                toggleModal,
                refreshPage,
                propsInputs,
                paso3Filtros,
                setPaso3Filtros,
                allDropdowns,
                paso4Filas,
                setPaso4Filas,
                IdFlujoDocumento,
                botonGuardarRef,
                isCreate
            };
        };

        const stepComponents = {
            [STEPS.stepOne.id]: {
                component: <Paso1 {...commonProps()} disableInputs={!puedeEditar} isCreate={isCreate} />,
                name: STEPS.stepOne.name,
            },
            [STEPS.stepTwo.id]: {
                component: <Paso2 {...commonProps()} disableInputs={!isCreate}/>,
                name: STEPS.stepTwo.name,
            },
            [STEPS.stepThree.id]: {
                component: <Paso3 {...commonProps()} disableInputs={!isCreate} />,
                name: STEPS.stepThree.name,
            },
            [STEPS.stepFour.id]: {
                component: <Paso4 {...commonProps()} disableInputs={!isCreate}/>,
                name: STEPS.stepFour.name,
            },
        };

        let stepsToRender = Object.values(stepComponents);


        return (
            <ModalForm
                titulo="Crear Documento"
                width="1200px"
                showModal={toggleModal}
                hasSaveButton={false}
            >
                <StepperFlujoDocumentos
                    steps={stepsToRender.map((step) => step.name)}
                    currentStepNumber={currentStep}
                    setCurrentStepNumber={setCurrentStep}
                    isObservated={false}
                />

                {React.cloneElement(stepsToRender[currentStep - 1].component, {
                    componentStep: currentStep,
                })}

                <div
                    className="d-flex justify-content-around py-4"
                    style={{borderTop: "1px solid #dee2e6"}}
                >
                    {currentStep !== STEPS.stepOne.id && (
                        <button
                            onClick={(e) => handleClick(e, "back")}
                            className="btn btn-primary generic-button-ficha-modal"
                        >
                            Atrás
                        </button>
                    )}
                    {currentStep !== stepsToRender.length ? (
                        <button
                            type="button"
                            onClick={(e) => handleClick(e, "save")}
                            className="btn generic-button-buscador generic-button-hover-verde"
                            style={{backgroundColor: "#8DBA38"}}
                        >
                            Continuar
                        </button>
                    ) : ((isCreate || puedeEditar) &&
                        <button
                            type="button"
                            onClick={(e) => handleClick(e, "save")}
                            className="btn generic-button-buscador generic-button-hover-verde"
                            style={{backgroundColor: "#8DBA38"}}
                            ref={botonGuardarRef}
                        >
                            Guardar
                        </button>
                    )}
                </div>
            </ModalForm>
        );
    }
;

CrearDocumento.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func,
};

export default CrearDocumento;
